import React from 'react';
import { Text, TextProps } from 'react-native';

import { useColors, useFont } from '../hooks/lesson-player.context';
import type { ColorsType } from '../interfaces';
import type { FontWeightStyle, FontsType } from '../interfaces/fonts.type';

export interface ThemedText2Props extends TextProps {
  type?: keyof ColorsType;
  fontType?: keyof FontsType;
  fontWeightStyle?: keyof FontWeightStyle;
  fontSize?: number;
  children?: React.ReactNode;
}

const ThemedText2: React.FC<ThemedText2Props> = ({
  type = 'gray',
  fontType = 'primary',
  fontWeightStyle = 'regular',
  fontSize = 16,
  ...props
}) => {
  const colors = useColors();
  const fonts = useFont();

  const color = colors[type] || colors.gray;
  const selectedFont =
    fonts?.[fontType]?.[fontWeightStyle] || fonts.primary.regular;

  return (
    <Text
      {...props}
      style={[
        {
          color,
          fontSize,
          ...selectedFont,
        },
        props.style,
      ]}
    >
      {props.children}
    </Text>
  );
};

export default ThemedText2;
